<template>

  <div class="position-relative d-inline-block dropdown-custom" @mouseover="onOver" @mouseleave="onLeave">

    <b-dropdown ref="dropdown" :no-caret="noCaret" :toggle-class="toggleClass"
                :variant="variant">

      <template #button-content>
        <slot name="button-content">
          <b-icon v-if="iconSettings" icon="gear-fill" aria-hidden="true"></b-icon>
        </slot>
      </template>

      <b-dropdown-item v-for="item in itemsRelationPages" :key="item.pageRelationId"
                       :disabled="item.accessGeneral === false" :to="{name:item.name}">
        {{ item.pageTitle }}
      </b-dropdown-item>


      <slot></slot>

    </b-dropdown>

  </div>

</template>
<script>
export default {
  props: {
    noCaret: {
      type: Boolean,
      default: false,
    },
    toggleClass: {
      type: String,
      default: "",
    },
    itemsRelationPages: Array,
    iconSettings: Boolean,
    variant: {
      type: String,
      default: "",
    }
  },
  methods: {
    onOver() {
      this.$refs.dropdown.visible = true;
    },
    onLeave() {
      this.$refs.dropdown.visible = false;
    }
  }
}
</script>
